document.addEventListener("DOMContentLoaded", function () {

  const menu = document.querySelector(".brands-mega-menu");
  const filters = document.querySelectorAll(".brands-filter span");
  const items = document.querySelectorAll(".brand-item");

  // 🔥 STOP theme JS interference
  if (menu) {
    menu.addEventListener("click", function(e) {
      e.stopPropagation();
    });

    menu.addEventListener("mousedown", function(e) {
      e.stopPropagation();
    });
  }

  filters.forEach(btn => {
    btn.addEventListener("click", function (e) {

      e.preventDefault();
      e.stopPropagation();

      filters.forEach(b => b.classList.remove("active"));
      this.classList.add("active");

      const letter = this.getAttribute("data-letter");

      items.forEach(item => {
        if (letter === "all") {
          item.style.display = "block";
        } else {
          item.style.display =
            item.getAttribute("data-letter") === letter ? "block" : "none";
        }
      });

    });
  });

});


// category mega menu js starts here


/* AUTO LOAD FIRST */
window.addEventListener("load", function () {

  const firstL1 = document.querySelector(".l1-item");
  if (!firstL1) return;

  const l1 = firstL1.dataset.l1;

  // activate L1
  firstL1.classList.add("active");

  // show L2
  const l2Group = document.querySelector(`.l2-group[data-l1="${l1}"]`);
  if (l2Group) {
    l2Group.classList.add("active");

    // get first L2
    const firstL2 = l2Group.querySelector(".l2-item");

    if (firstL2) {
      const l2 = firstL2.dataset.l2;

      // OPTIONAL: highlight L2
      firstL2.classList.add("active");

      // show L3
      const l3Group = document.querySelector(
        `.l3-group[data-l1="${l1}"][data-l2="${l2}"]`
      );

      if (l3Group) {
        l3Group.classList.add("active");
      }
    }
  }

});

document.addEventListener("mouseover", function (e) {

  if (!e.target.closest(".category-mega")) return;

  // ===== L1 → L2 + AUTO L2 + L3 =====
  const l1Item = e.target.closest(".l1-item");

  if (l1Item) {
    const l1 = l1Item.dataset.l1;

    // Active L1
    document.querySelectorAll(".l1-item").forEach(i => i.classList.remove("active"));
    l1Item.classList.add("active");

    // Show L2
    document.querySelectorAll(".l2-group").forEach(g => g.classList.remove("active"));
    const l2Group = document.querySelector(`.l2-group[data-l1="${l1}"]`);
    if (l2Group) {
      l2Group.classList.add("active");

      // 🔥 AUTO SELECT FIRST L2
      const firstL2 = l2Group.querySelector(".l2-item");

      document.querySelectorAll(".l2-item").forEach(i => i.classList.remove("active"));

      if (firstL2) {
        firstL2.classList.add("active");

        const l2 = firstL2.dataset.l2;

        // 🔥 AUTO SHOW L3
        document.querySelectorAll(".l3-group").forEach(g => g.classList.remove("active"));

        document
          .querySelector(`.l3-group[data-l1="${l1}"][data-l2="${l2}"]`)
          ?.classList.add("active");
      }
    }
  }

  // ===== L2 → L3 =====
  const l2Item = e.target.closest(".l2-item");

  if (l2Item) {
    const l1 = l2Item.dataset.l1;
    const l2 = l2Item.dataset.l2;

    document.querySelectorAll(".l2-item").forEach(i => i.classList.remove("active"));
    l2Item.classList.add("active");

    document.querySelectorAll(".l3-group").forEach(g => g.classList.remove("active"));

    document
      .querySelector(`.l3-group[data-l1="${l1}"][data-l2="${l2}"]`)
      ?.classList.add("active");
  }

});
// category mega menu js ends here


// brand menu js
document.addEventListener('input', function(e) {

  if (!e.target.classList.contains('brand-search-input')) return;

  const value = e.target.value.toLowerCase();
  const items = e.target.closest('.brands-dropdown').querySelectorAll('.brand-item');

  items.forEach(item => {
    const name = item.dataset.name;
    item.style.display = name.includes(value) ? 'block' : 'none';
  });

});


// document.addEventListener('click', function(e) {

//   // 🚫 completely isolate brands dropdown
//   if (e.target.closest('.brands-dropdown')) {
//     e.stopPropagation(); // 👈 stronger than stopPropagation
//   }

// }, true); // 👈 capture phase (VERY IMPORTANT)


// mobile menu

document.querySelectorAll('.mobile-menu .nav-dropdown__link, .mobile-menu .collections_menu > a')
.forEach(link => {

  link.addEventListener('click', (e) => {

    const parentLi = link.parentElement;
    const submenu = parentLi.querySelector(':scope > ul');

    if (!submenu || !submenu.classList.contains('nav-dropdown')) return;

    const href = link.getAttribute('href');

    // 👉 CASE 1: href="#" → always act like toggle
    if (href === '#') {

      e.preventDefault();
      e.stopPropagation();

      const isOpen = submenu.classList.contains('open');

      const siblings = parentLi.parentElement.querySelectorAll(':scope > li > ul.open');
      siblings.forEach(ul => {
        if (ul !== submenu) closeMenu(ul);
      });

    if (isOpen) {
      closeMenu(submenu);
      rotateArrow(parentLi, false);
    } else {
      openMenu(submenu);
      rotateArrow(parentLi, true);
    }

      return;
    }

    // 👉 CASE 2: normal links → only last SVG toggles
    const svgs = link.querySelectorAll('svg');

    if (!svgs.length) return; // no arrow → normal navigation

    const lastSvg = svgs[svgs.length - 1];

    if (!e.target.closest('svg') || !lastSvg.contains(e.target)) {
      return; // ✅ allow navigation
    }

    // 👉 ONLY arrow click
    e.preventDefault();
    e.stopImmediatePropagation();

    const isOpen = submenu.classList.contains('open');

    const siblings = parentLi.parentElement.querySelectorAll(':scope > li > ul.open');
    siblings.forEach(ul => {
      if (ul !== submenu) closeMenu(ul);
    });

    if (isOpen) {
      closeMenu(submenu);
      rotateArrow(parentLi, false);
    } else {
      openMenu(submenu);
      rotateArrow(parentLi, true);
    }

  });

});
function rotateArrow(parentLi, isOpen) {
  const arrow = parentLi.querySelector('.l2-chv');
  if (!arrow) return;

  if (isOpen) {
    arrow.classList.add('rotated');
  } else {
    arrow.classList.remove('rotated');
  }
}

/* ---------- FUNCTIONS ---------- */

function openMenu(menu) {
  menu.classList.add('open');
  menu.style.visibility = 'visible';
  menu.style.opacity = '1';
  menu.style.position = 'static';
  menu.style.border = 'none';
  menu.style.padding = '0';

  // set height for animation
  menu.style.height = menu.scrollHeight + 'px';

  menu.addEventListener('transitionend', function handler() {
    menu.style.height = 'auto';
    menu.removeEventListener('transitionend', handler);
  });
}


function closeMenu(menu) {
  // close all nested children also
  const childMenus = menu.querySelectorAll('.nav-dropdown.open');
  childMenus.forEach(child => closeMenu(child));

  menu.style.height = menu.scrollHeight + 'px';

  requestAnimationFrame(() => {
    menu.style.height = '0px';
    menu.style.padding = '0px';
    menu.style.opacity = '0';
    menu.style.visibility = 'hidden';
  });

  menu.classList.remove('open');
}


document.querySelectorAll('.nav-bar__item').forEach(item => {

  item.addEventListener('mouseenter', function () {

    // 🔥 CLOSE ALL FIRST
    document.querySelectorAll('.nav-bar__item').forEach(i => {
      i.classList.remove('is-dropdown-open');

      const dd = i.querySelector('.nav-dropdown');
      const link = i.querySelector('.nav-bar__link');

      if (dd) dd.setAttribute('aria-hidden', 'true');
      if (link) link.setAttribute('aria-expanded', 'false');
    });

    // 🔥 OPEN CURRENT
    this.classList.add('is-dropdown-open');

    const dropdown = this.querySelector('.nav-dropdown');
    const link = this.querySelector('.nav-bar__link');

    if (dropdown) dropdown.setAttribute('aria-hidden', 'false');
    if (link) link.setAttribute('aria-expanded', 'true');

  });

});

document.querySelector('.nav-bar').addEventListener('mouseleave', () => {
  document.querySelectorAll('.nav-bar__item').forEach(i => {
    i.classList.remove('is-dropdown-open');
  });
});